module.exports = __webpack_public_path__ + "img/QSP.21427b24.svg";